<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end;">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on">
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="queryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-autocomplete
                v-model="queryParams.shopId"
                :items="shopList"
                label="Choose Shop..."
                item-text="name"
                item-value="id"
                :disabled="checkRoleShop() ? true : false"
                color="blue-grey lighten-2"
                menu-props="auto"
                :hide-no-data="true"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm4>
              <v-autocomplete
                v-model="queryParams.departmentId"
                :items="departmentList"
                color="blue-grey lighten-2"
                label="Choose Department..."
                item-text="name"
                menu-props="auto"
                item-value="id"
                :hide-no-data="true"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm4>
              <v-autocomplete
                v-model="queryParams.warehouseId"
                :items="warehouseList"
                label="Choose Warehouse..."
                item-text="name"
                item-value="id"
                color="blue-grey lighten-2"
                menu-props="auto"
                :hide-no-data="true"
                @change="changeWarehouse()"
                :disabled="checkRoleWarehouse() ? true : false"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm4>
              <v-autocomplete
                v-model="queryParams.binId"
                :items="binList"
                label="Choose Bin..."
                item-text="name"
                item-value="id"
                color="blue-grey lighten-2"
                menu-props="auto"
                :hide-no-data="true"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="reason"
                label="reason"
                type="text"
                v-model="queryParams.reason"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="serialNo"
                label="RMR No"
                type="text"
                v-model="queryParams.serialNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="rmrList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn
                  flat
                  icon
                  color="blue lighten-2"
                  @click="onEdit(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  flat
                  icon
                  color="warning"
                  :loading="buttonLoading"
                  @click.stop="reprint(props.item.id)"
                >
                  <v-icon>print</v-icon>
                </v-btn>
              </td>
              <td>{{ props.item.status }}</td>
              <td>{{ props.item.issueDateInMilliSeconds | formatMsDate }}</td>
              <td>{{ props.item.issueNo }}</td>
              <td>{{ props.item.serialNo }}</td>
              <td>{{ props.item.shopName }}</td>
              <td>{{ props.item.departmentName }}</td>
              <td>{{ props.item.warehouseName }}</td>
              <td>{{ props.item.binName }}</td>
              <td>{{ props.item.reason }}</td>
              <td>
                {{ props.item.createdDateInMilliSeconds | formatMsDateTime }}
              </td>
              <td>{{ props.item.createdBy }}</td>
              <td>
                {{ props.item.updatedDateInMilliSeconds | formatMsDateTime }}
              </td>
              <td>{{ props.item.updatedBy }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { departmentService } from "../../services/department-service";
import { emrService } from "../../services/emr-service";
import { commonService } from "../../services/common-service";
import { shopService } from "../../services/shop-service";
import { warehouseService } from "../../services/warehouse-service";

export default {
  name: "RMRList",
  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    buttonLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Manufacturing Management",
        disabled: true,
      },
      {
        text: "RMR",
        disabled: true,
      },
    ],
    headers: [
      { text: "Action", value: "name", sortable: false },
      { text: "Status", value: "status" },
      { text: "Issue Date", align: "left", value: "issueDate" },
      { text: "Issue No", value: "issueNo" },
      { text: "RMR No", value: "serialNo" },
      { text: "Shop Name", value: "shop.name" },
      { text: "Deprtment Name", value: "department.name" },
      { text: "Warehouse Name", value: "warehouse.name" },
      { text: "Bin Name", value: "bin.name" },
      { text: "Reason", value: "reason" },
      { text: "Created Date", value: "createdDate" },
      { text: "Created By", value: "createdBy" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    totalRows: 0,
    statusList: [
      { label: "All", value: "" },
      { label: "DRAFT", value: "DRAFT" },
      { label: "CONFIRM", value: "CONFIRM" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      serialNo: "",
      type: "RMR",
      shopId: "",
      departmentId: "",
      warehouseId: "",
      binId: "",
      binIds: [],
      status: "",
      reason: "",
      isAddDetails: false,
      checkLocationMovement: false,
    },
    departmentList: [],
    rmrList: [],
    shopList: [],
    warehouseList: [],
    binList: [],
  }),
  watch: {
    pagination: {
      handler() {
        this.getRMRList();
      },
      deep: true,
    },
  },
  created() {
    this.queryParams.warehouseId = this.checkRoleWarehouse();
    this.queryParams.shopId = this.checkRoleShop();

    this.getDepartmentByStatus();
    this.getAllShop();
    this.getActiveWarehouse().then(() => {
      if (this.queryParams.warehouseId) {
        this.getWarehouseBinList();
      }
    });
    if (this.user.roleName == "WAREHOUSE_STAFF") {
      this.user.selectedBinList.forEach((v) =>
        this.queryParams.binIds.push(v.id)
      );
    }
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.issueNo) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }
    if (this.$route.query.serialNo) {
      this.queryParams.serialNo = this.$route.query.serialNo;
    }
    if (this.$route.query.type) {
      this.queryParams.type = this.$route.query.type;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = Number(this.$route.query.shopId);
    }
    if (this.$route.query.departmentId) {
      this.queryParams.departmentId = Number(this.$route.query.departmentId);
    }
    if (this.$route.query.warehouseId) {
      this.queryParams.warehouseId = Number(this.$route.query.warehouseId);
    }
    if (this.$route.query.binId) {
      this.queryParams.binId = Number(this.$route.query.binId);
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.reason) {
      this.queryParams.reason = this.$route.query.reason;
    }
    if (this.$route.query.isAddDetails) {
      this.queryParams.isAddDetails = this.$route.query.isAddDetails;
    }
    if (this.$route.query.checkLocationMovement) {
      this.queryParams.checkLocationMovement = this.$route.query.checkLocationMovement;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
  },
  methods: {
    checkRoleWarehouse() {
      if (
        this.user.roleName == "WAREHOUSE_MANAGER" ||
        this.user.roleName == "WAREHOUSE_STAFF" ||
        this.user.roleName == "BRANCH_ADMIN" ||
        this.user.roleName == "PROCUREMENT_MANAGER"
      ) {
        return this.user.warehouseId;
      } else if (
        this.user.roleName == "SALE_MANAGER" ||
        this.user.roleName == "GENERAL_MANAGER" ||
        this.user.roleName == "SALE" ||
        this.user.roleName == "PRODUCTION_MANAGER"
      ) {
        return this.user.shop.warehouseId;
      }
      return "";
    },
    checkRoleShop() {
      if (
        this.user.roleName == "BRANCH_ADMIN" ||
        this.user.roleName == "SALE_MANAGER" ||
        this.user.roleName == "GENERAL_MANAGER" ||
        this.user.roleName == "PRODUCTION_MANAGER" ||
        this.user.roleName == "PROCUREMENT_MANAGER"
      ) {
        return this.user.shopId;
      }
      return "";
    },
    getDepartmentByStatus() {
      departmentService
        .getDepartmentsByStatus("ACTIVE")
        .then((res) => {
          this.departmentList = res.data;
          this.departmentList.unshift({ id: "", name: "---All---" });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAllShop() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
          this.shopList.unshift({ id: "", name: "---All---" });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getActiveWarehouse() {
      return warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.warehouseList = res.data;
          this.warehouseList.unshift({ id: "", name: "---All---" });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeWarehouse() {
      this.queryParams.binId = "";
      this.binList = [];
      this.getWarehouseBinList();
    },
    getWarehouseBinList() {
      if (this.user.roleName == "WAREHOUSE_STAFF") {
        this.binList = this.user.selectedBinList;
      } else {
        let warehouse = commonService.search(
          "id",
          this.queryParams.warehouseId,
          this.warehouseList
        );
        if (warehouse) {
          this.binList = warehouse.binList;
        }
      }
      this.binList.unshift({ id: "", name: "---All---" });
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "rmrs", query: this.queryParams });
      this.getRMRList();
    },
    getRMRList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      this.queryParams.isAddDetails = false;
      emrService
        .getEMRList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.rmrList = res.data.emrList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/rmr/new");
    },
    onEdit(emr) {
      // go to details page
      this.$router.push("/rmr/" + emr.id);
    },
    reprint(id) {
      this.buttonLoading = true;
      emrService.printEMRInvoice(id).then((res) => {
        var blob = res;
        emrService.showWindowDialog(blob, "invoice-" + id);
        this.buttonLoading = false;
      });
    },
  },
};
</script>
